import React from 'react'
import PropTypes from 'prop-types'
import {Alert} from 'antd'
import logoInviso from 'assets/logo.svg'

import './index.css'
import OtpForm from './OtpForm'
import EmailForm from './EmailForm'

class Login extends React.Component {
  state = {
    email: null,
  }

  componentDidMount() {
    const email = localStorage.getItem('email')
    if (email) {
      this.setState({email})
    }
  }

  requestOtp = ({email}) => {
    // Email is stored and reloaded from local storage because when this app is
    // used as a webapp (added to home screen) on IOS, switching to another app
    // and back again forces a full reload. Since the login process needs users
    // to check their email or SMS to get the OTP, this does prove to be a big
    // problem unless we can "remember" that state between reloads.
    this.setState({email}, () => {
      localStorage.setItem('email', email)
      this.props.requestOtp(email)
    })
  }

  clearEmail = () => {
    this.setState({email: null}, () => {
      localStorage.removeItem('email')
      this.props.clearError()
    })
  }

  signInByOtp = async ({otp}) => {
    const email = this.state.email
    const token = await this.props.signInByOtp({email, otp})
    if (token) {
      localStorage.removeItem('email')
    }
  }

  render() {
    const {error, loading} = this.props

    return (
      <div className="login">
        <div className="logo">
          <img src={logoInviso} alt="EFKT" />
        </div>

        {error && !loading &&
          <Alert type="error" message={error} />
        }

        {!this.state.email &&
          <EmailForm onSubmit={this.requestOtp} />
        }
        {this.state.email &&
          <OtpForm
            loading={loading}
            onSubmit={this.signInByOtp}
            onCancel={this.clearEmail}
            email={this.state.email}
          />
        }
      </div>
    )
  }
}

Login.propTypes = {
  signInByOtp: PropTypes.func.isRequired,
  requestOtp: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default Login
